var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.info)?_c('ass-detail',{attrs:{"item":_vm.info.item,"message":_vm.info}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }